import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SplitParagraphs from "components/SplitParagraphs";

type ClinicalHistorySectionProps = {
  clinicalHistory?: string | null;
};

const ClinicalHistorySection = ({
  clinicalHistory,
}: ClinicalHistorySectionProps) => (
  <>
    <dt>Clinical History</dt>
    {clinicalHistory ? (
      <dd>
        <SplitParagraphs
          paragraph={clinicalHistory}
          className="Specimen__content--prewrap Specimen__content--wordWrap"
        />
      </dd>
    ) : (
      <dd className="Specimen__contentContainer__missing">
        <FontAwesomeIcon icon="exclamation-circle" color={"var(--red)"} />{" "}
        Missing Clinical History
      </dd>
    )}
  </>
);

export default ClinicalHistorySection;
